import { ClientDto } from '../../../../api';
import ProjectQueries from './ProjectQueries';
import ProjectsDataGrid from './ProjectsDataGrid';

/**
 * Displays projects associated with a particular client in a Data Grid
 * @returns Projects Data Grid
 */
function SelectProjects(props: { selectedClient: ClientDto }) {
  const { selectedClient } = props;
  const { FetchProjects } = ProjectQueries();
  const { data: projects } = FetchProjects(selectedClient.id);

  return <ProjectsDataGrid selectedClient={selectedClient} projects={projects} />;
}

export default SelectProjects;
